import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/gdstd4.webp";
import { Col } from 'react-bootstrap';
import { renderTextBlock } from 'src/components/RenderTextBlocks';


export const projectDetails: ProjectInterface = {
    url: "gdstd4",
    title: "Gamedev Study 4",
    summary: "Prototype for studying AI and lighting in Unity.",
    description: `I made this prototype primarily for studying game AI and NavMeshes, but I also used it to understand a bit more about lighting in Unity.`,
    year: "2022",
    tags: ["Third Person", "Prototype", "Study Project", "Unity"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: "",
    isCoverType: true,
    haveTags: true,
    projectType: ProjectType.STUDY,
    roles: ["Programmer", "Study"],
    technologies: ["Unity", "C#", "WebGL"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "Learning AI and a bit of lighting",
    linkData:
        [
            { type: 'github', url: "https://github.com/lucasctnh/gdstd-4-unity" },
            { type: 'text', url: "https://play.unity.com/pt/games/2cad57b2-d4be-4202-88b3-05920c8ee2de/game-dev-study-4" },
        ],
    relatedProjects: ["GDSTD1", "GDSTD2", "CheckMore"],
};


export function GDSTD4() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                isLeftFirst={false}
                leftContent={
                    <Col size={12} md={12} className="a-body-left" style={{ marginTop: "0" }}>
                            <div className="a-subtitle">
                                Afterthoughts
                            </div>

                            <div className="a-body-description">
                                {renderTextBlock(`I've been wanting to learn about AI for a while so I decided to make a small prototype. I used the [Third Person Starter Pack](https://assetstore.unity.com/packages/essentials/starter-assets-third-person-character-controller-196526) from Unity as a base so I could focus solely on my objective. The AI simply roams around and follow player when near, I wanted to also add a fighting element but I thought this would be out of the scope. I prefer to make another prototype focused on fighting and them one with the two combined.

I also saw an opening to understand the lighting on Unity a little better. With that I learnt how to use light probes to simulate dynamic lighting with a baked source.`)}
                            </div>
                        </Col>
                }
                rightContent={
                    null
                }>

                {/* <div className='a-body'>
                    <div className="a-body-block">
                        <Col size={12} md={12} className="a-body-left">
                            <div className="a-subtitle">
                                Afterthoughts
                            </div>

                            <div className="a-body-description">
                                {renderTextBlock(`I've been wanting to learn about AI for a while so I decided to make a small prototype. I used the [Third Person Starter Pack](https://assetstore.unity.com/packages/essentials/starter-assets-third-person-character-controller-196526) from Unity as a base so I could focus solely on my objective. The AI simply roams around and follow player when near, I wanted to also add a fighting element but I thought this would be out of the scope. I prefer to make another prototype focused on fighting and them one with the two combined.

I also saw an opening to understand the lighting on Unity a little better. With that I learnt how to use light probes to simulate dynamic lighting with a baked source.`)}
                            </div>
                        </Col>
                    </div>
                </div> */}
            </ProjectBase>
        </div>
    );
}